import React, { Component } from 'react';

import logo from '../assets/logo.jpeg';

class EpisodeCard extends Component {
    constructor(props) {
        super(props);
        this.setTrack = this.setTrack.bind(this);

    }
    setTrack(){
        this.props.setTrack(this.props.url, true);
    }

    render() {
        return (
            <li className = "feed-container">
                <button onClick={this.setTrack}>
                    <h2 className = "feed-headline"> {this.props.title} </h2>
                    <p className = "feed-date">{new Date(Date.parse(this.props.date)).toDateString()}</p>
                    <p className = "feed-description"> {this.props.description} </p>
                </button>
            </li>
        )

    }
}
export default EpisodeCard; 